export const REWARD_VIDEO_AD_BLOCKED = "REWARD_VIDEO_AD_BLOCKED";
export const REWARD_VIDEO_NO_CAMPAIGN = "REWARD_VIDEO_NO_CAMPAIGN";
export const REWARD_VIDEO_READY = "REWARD_VIDEO_READY";
export const REWARD_VIDEO_RESIZE = "REWARD_VIDEO_RESIZE";
export const REWARD_VIDEO_OPEN = "REWARD_VIDEO_OPEN";
export const REWARD_VIDEO_CLOSE = "REWARD_VIDEO_CLOSE";
export const REWARD_VIDEO_COMPLETION = "REWARD_VIDEO_COMPLETION";
export const REWARD_VIDEO_IRONSOURCE = "REWARD_VIDEO_IRONSOURCE";
export const REWARD_VIDEO_SUPPORT = "REWARD_VIDEO_SUPPORT";
export const REWARD_VIDEO_STALE = "REWARD_VIDEO_STALE";

export const rewardVideoAdBlocked = data => ({
  type: REWARD_VIDEO_AD_BLOCKED,
  data
});

export const rewardVideoReady = data => ({
  type: REWARD_VIDEO_READY,
  data
});

export const rewardVideoOpen = data => ({
  type: REWARD_VIDEO_OPEN,
  data
});

export const rewardVideoComplete = data => ({
  type: REWARD_VIDEO_COMPLETION,
  data
});

export const setIronRV = data => ({
  type: REWARD_VIDEO_IRONSOURCE,
  data
});

export const setRewardVideoSupport = data => ({
  type: REWARD_VIDEO_SUPPORT,
  data
});

export const updateRewardVideoStale = data => ({
  type: REWARD_VIDEO_STALE,
  data
});